import { render, staticRenderFns } from "./addInventoryStock.vue?vue&type=template&id=72c4b070&scoped=true"
import script from "./addInventoryStock.vue?vue&type=script&lang=js"
export * from "./addInventoryStock.vue?vue&type=script&lang=js"
import style0 from "./addInventoryStock.vue?vue&type=style&index=0&id=72c4b070&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c4b070",
  null
  
)

export default component.exports